export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-1a5902f3',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
  googleAnalyticsId: 'G-WZ7RJH83XV',
};
